import React, { useState } from 'react';
import Grid from "@material-ui/core/Grid";
import { makeStyles } from '@material-ui/core/styles';
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from '@material-ui/lab';
import Button from "@material-ui/core/Button";
import EditIcon from '@material-ui/icons/Edit';
import Delete from '@material-ui/icons/Delete';

import { uri } from '../../../../help/Api';

import { ButtonGroup, colors, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/AddBox';
import SaveIcon from '@material-ui/icons/Save';
import toast, { Toaster } from 'react-hot-toast';

import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import SubUnitsTables from './SubUnitsTables';
import SubUnitForm from './SubUnitForm';
import BarcodeGenrateCon from '../items/barcodePrint/BarcodeGenrateCon';

const unitValidateSchema = (t) => yup.object().shape({

  unit: yup.string().required(t("select-unit")),
  perc: yup.string().required(t("select-packaging")),
  purch: yup.string().required(t("select-purchase-value")),
  sale: yup.string().required(t("select-sale-value")),
  barcode: yup.string().required(t("no-barcode-for-item")),
})

export const useStylesSunComp = makeStyles((theme) => ({
  textField3: {
    width: '100%',
    padding: 5,
  },
  textField44: {
    width: '50%',
    marginTop: 5,
    marginBottom: -5,
  },
  headerTitle: {
    backgroundColor: colors.red[50],
    textAlign: "center",
    fontSize: 14,
    width: "100%",
  },
  textField: {
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": { color: 'navy', fontSize: '0.8rem', },
    "& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": {
      color: 'navy', fontSize: '0.7rem',
      lineHeight: '0.5rem',
    }, "& .MuiOutlinedInput-inputMarginDense":
      { paddingLeft: 4, paddingRight: 4, paddingTop: 6, paddingBottom: 4, textAlign: 'center', fontSize: '1rem' }, margin: 3,
  },

  root: {
    direction: 'rtl',
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
    paddingRight: '1px',
    boxShadow: 'rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;',
  },

}));

export const defaultDataUnit = {
  id: '',
  no: 0,
  curr: '',
  unit: '',
  unitName: '',
  perc: '',
  purch: '',
  sale: '',
  barcode: '',
  unit_convert: '',
  editPerc: false,
  editUnit: false,
  editSale: false,
  editPurch: false,
  editBarcode: false,
  defUnit: {},
}
const barcodePrintValue = {
  sale: 0,
  barcode: '',
}

export default function SubUnits(props) {

  const { items, AutoOptions, units, currUnitList, setCurrUnitList,
    confirmDialog, setConfirmDialog, allow, setAllow,itemsComms,
    paramsUnit,
    setParamsUnit
  } = props;
  const { t } = useTranslation(["forms", "translation"]);

  const classes = useStylesSunComp();
  const [valueUnit, setValueUnit] = React.useState([]);
  const [submitting, setSubmitting] = useState(false);
  // const [data, setData] = useState(defaultData);
  const [barodePrint, setBarodePrint] = useState(barcodePrintValue);
  const [isNew, setIsNew] = useState(true);
  const [barcodeNewDialogOpen, setBarcodeNewDialogOpen] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    var oldData1 = currUnitList.filter((obj) => obj.unit == paramsUnit.unit);
    let newData = {
      ...paramsUnit,
      purch: Number(paramsUnit.purch),
      sale: Number(paramsUnit.sale),
      perc: Number(paramsUnit.perc),
      no: currUnitList.length,
      editPerc: false,
      editUnit: false,
      editSale: false,
      editPurch: false,
      editBarcode: false,
      defUnit: {},
    };
    if (items.unit == paramsUnit.unit) {
      alert(t("unit-exists-as-default"));
    } else if (oldData1.length != 0 && isNew) {
      alert(t("unit-exists-as-sub"));

    } else {
      unitValidateSchema(t).validate(paramsUnit, { abortEarly: false })
        .then(function (valid) {

          setCurrUnitList([...currUnitList, newData]);
          setParamsUnit(defaultDataUnit);
          setValueUnit(null);
          setIsNew(true);
          setSubmitting(false);

        }).catch(function (err) {
          toast.error(err.errors[0]);
          setSubmitting(true);
          console.log(err.errors);
        })
    }
  }

  const onChangeData = (prop) => (event) => {
    if (prop === "perc") {
      let i = {
        purch_price: Number(items.purch_price),
        sale_price: Number(items.sale_price),
        perc: Number(event.target.value),
      };
      let addbar = parseFloat(currUnitList.length + 1);
      let barcode = items.barcode + "-" + addbar;
      let sal = (parseFloat(i.sale_price) * parseFloat(i.perc)).toFixed(2);
      let purc = (parseFloat(i.purch_price) * parseFloat(i.perc)).toFixed(2);
      setParamsUnit({
        ...paramsUnit, [prop]: event.target.value,
        barcode: barcode, purch: purc, sale: sal
      });

    } else {
      setParamsUnit({ ...paramsUnit, [prop]: event.target.value })
    }
  }
  const onChangeAutoData = (prop, newValue) => {
    setValueUnit(newValue);
    setParamsUnit({
      ...paramsUnit,
      unit: newValue.id,
      unitName: newValue.name
    });

  };

  const openPrint = (row) => {
    setBarodePrint({
      ...barodePrint,
      sale: row.sale,
      barcode: row.barcode
    });
    setAllow({ ...allow, item: true });
    setBarcodeNewDialogOpen(true);
  };
  return (
    <Grid className={classes.root} container>
      <Toaster />
      <Typography
        size="small"
        className={classes.headerTitle}
        style={{ backgroundColor: colors.red[50], fontWeight: "bold" }}
        color="primary"
      >
        {t("major-sub-units")}
      </Typography>
      <SubUnitForm
        {...{
          paramsUnit,
          valueUnit,
          onSubmit,
          onChangeData,
          units,
          onChangeAutoData,
        }}
      />
      <SubUnitsTables
        {...{
          currUnitList,
          setCurrUnitList,
          items,
          units,
          confirmDialog,
          setConfirmDialog,
          openPrint,

        }}
      />
      {/* {allow.item ? (
        <BarcodeGenrateDialog
          open={barcodeDialogOpen}
          setOpen={setBarcodeDialogOpen}
          data={items}
          permiCuCo={AutoOptions.permiCuCo.CWVat}
          barcode={barodePrint.barcode}
          sale_price={Number(barodePrint?.sale)}
          AutoOptions={AutoOptions}

        />
      ) : null} */}
      {allow.item ? (
        <BarcodeGenrateCon
          open={barcodeNewDialogOpen}
          setOpen={setBarcodeNewDialogOpen}
          data={items}
          permiCuCo={AutoOptions.permiCuCo.CWVat}
          barcode={barodePrint.barcode}
          sale_price={Number(barodePrint?.sale)}
          AutoOptions={AutoOptions}
          itemCom={itemsComms ?? []}
          type={items.type}
        />
      ) : null}
    </Grid>
  )

}